import { getSecureAccountsApi, getMainApi, putMainApi, putAccountsApi } from "@Shared/utils/ajax";
export const getDisclaimers = async () => {
  return getSecureAccountsApi({}, "/customize/disclaimer");
};
export const getBrokerageDisclaimers = async () => {
  return getMainApi({}, "/brokerage/customize/disclaimer");
};
export const putBrokerageDisclaimers = async (disclaimers, defaultDisclaimerEnabled) => {
  return putMainApi({
    disclaimers,
    defaultDisclaimerEnabled
  }, "/brokerage/customize/disclaimer");
};
export const putDisclaimers = async (disclaimers, defaultDisclaimerEnabled) => {
  return putAccountsApi({
    disclaimers,
    defaultDisclaimerEnabled
  }, "/customize/disclaimer");
};